// extracted by mini-css-extract-plugin
export default {"rating":"jJ-z","numberOfStars":"kJ-z","count":"lJ-z","barGraphSpacing":"mJ-z","barGraph":"nJ-z"};